import { useEffect, useState } from "react";
import { IFood } from "../models/IFood";
import { IFoodDiscount } from "../models/IFoodDiscount";
import { getAllFood, deleteFood, setMenuStatusByRestaurant } from "../services/food";
import { getFoodDiscountsByRestaurant } from "../services/foodDiscount";
import FoodUpdatePopup from "./FoodUpdatePopup";
import AddNewFoodPopup from "./AddNewFoodPopup";
import FoodDiscountPopup from "./FoodDiscountPopup";

function MyFoods({
  selectedRestaurantId,
  selectedFood,
  onSelectFood
}: {
  selectedRestaurantId?: string,
  selectedFood?: IFood,
  onSelectFood: (food: IFood) => void
}) {

  const [allFoods, setallFoods] = useState<IFood[]>();
  const [loading, setLoading] = useState(false);
  const [popupFood, setPopupFood] = useState<IFood | null>(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showNewPopup, setShowNewPopup] = useState(false);
  const [deletingId, setDeletingId] = useState<string | null>(null);
  const [confirmFood, setConfirmFood] = useState<IFood | null>(null);
  const [discountFood, setDiscountFood] = useState<IFood | null>(null);
  const [showDiscountPopup, setShowDiscountPopup] = useState(false);
  const [activeDiscounts, setActiveDiscounts] = useState<IFoodDiscount[]>([]);

  // Toplu menü aç/kapat
  const [bulkTarget, setBulkTarget] = useState<boolean | null>(null);
  const [bulkBusy, setBulkBusy] = useState(false);
  const [bulkResult, setBulkResult] = useState<{ type: "success" | "error"; text: string } | null>(null);

  useEffect(() => {
    if (selectedRestaurantId) {
      getAllFoodNow(selectedRestaurantId);
      loadActiveDiscounts(selectedRestaurantId);
    }
  }, [selectedRestaurantId]);

  const loadActiveDiscounts = (restaurantId: string) => {
    getFoodDiscountsByRestaurant(restaurantId, true, 0, 100)
      .then((res) => setActiveDiscounts(res.data ?? []))
      .catch(() => setActiveDiscounts([]));
  };

  useEffect(() => {}, [selectedFood]);

  const getAllFoodNow = async (restaurantId: string | undefined) => {
    setLoading(true);
    const delay = (ms: number): Promise<void> =>
      new Promise(resolve => setTimeout(resolve, ms));
    await delay(2000);
    if (restaurantId) {
      getAllFood(restaurantId)
        .then((response) => {
          if (response.data) {
            setallFoods(response.data);
          } else {
            setallFoods([]);
          }
        })
        .catch((err) => {
          setallFoods([]);
          console.error("Yemekler yüklenirken hata oluştu:", err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const EditFood = (food: IFood) => {
    if (food) {
      setPopupFood(food);
      setShowPopup(true);
    }
  };

  const ManageDiscounts = (food: IFood) => {
    setDiscountFood(food);
    setShowDiscountPopup(true);
  };

  const handleDelete = (food: IFood) => {
    setConfirmFood(food);
  };

  const confirmDelete = () => {
    if (!confirmFood) return;
    const food = confirmFood;
    setConfirmFood(null);
    setDeletingId(food.id);
    deleteFood(food.id)
      .then(() => {
        setTimeout(() => {
          setDeletingId(null);
          if (selectedRestaurantId) getAllFoodNow(selectedRestaurantId);
        }, 3000);
      })
      .catch(() => {
        setDeletingId(null);
      });
  };

  const handlePopupSaved = () => {
    if (selectedRestaurantId) {
      getAllFoodNow(selectedRestaurantId);
      loadActiveDiscounts(selectedRestaurantId);
    }
  };

  // Sonuç bildirimi bir süre sonra kendiliğinden kaybolsun
  useEffect(() => {
    if (!bulkResult) return;
    const timer = setTimeout(() => setBulkResult(null), 6000);
    return () => clearTimeout(timer);
  }, [bulkResult]);

  const runBulkStatus = () => {
    if (bulkTarget === null || !selectedRestaurantId) return;
    const target = bulkTarget;
    setBulkBusy(true);
    setBulkResult(null);
    setMenuStatusByRestaurant(selectedRestaurantId, target)
      .then((res) => {
        const updatedCount = res.data?.updatedCount ?? 0;
        const totalCount = res.data?.totalCount ?? 0;
        setBulkTarget(null);
        setBulkResult({
          type: "success",
          text: updatedCount > 0
            ? `${updatedCount} ürün ${target ? "açıldı" : "kapatıldı"}.`
            : `Değişen ürün yok — ${totalCount} ürünün tamamı zaten ${target ? "açık" : "kapalı"}.`,
        });
        handlePopupSaved();
      })
      .catch((err) => {
        const code = err?.response?.data?.[0]?.code;
        setBulkTarget(null);
        setBulkResult({
          type: "error",
          text:
            code === "RestourantAccessDenied" ? "Bu restoranın menüsünü değiştirme yetkiniz yok."
            : code === "RestourantNotFound" ? "Restoran bulunamadı."
            : "Menü durumu güncellenemedi. Lütfen tekrar deneyin.",
        });
      })
      .finally(() => setBulkBusy(false));
  };

  const activeFoods = allFoods?.filter(f => f.foodIsEnabled) ?? [];
  const passiveFoods = allFoods?.filter(f => !f.foodIsEnabled) ?? [];

  const FoodCard = ({ food }: { food: IFood }) => (
    <div className="col-6 col-md-4 col-lg-3 mb-3">
      <div
        className="card h-100 border-0"
        style={{
          borderRadius: '14px',
          overflow: 'hidden',
          boxShadow: food.foodIsEnabled
            ? '0 4px 14px rgba(25, 135, 84, 0.22)'
            : '0 4px 14px rgba(220, 53, 69, 0.15)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          cursor: 'pointer',
        }}
        onMouseEnter={e => {
          (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-4px)';
          (e.currentTarget as HTMLDivElement).style.boxShadow = food.foodIsEnabled
            ? '0 8px 22px rgba(25, 135, 84, 0.32)'
            : '0 8px 22px rgba(220, 53, 69, 0.25)';
        }}
        onMouseLeave={e => {
          (e.currentTarget as HTMLDivElement).style.transform = 'translateY(0)';
          (e.currentTarget as HTMLDivElement).style.boxShadow = food.foodIsEnabled
            ? '0 4px 14px rgba(25, 135, 84, 0.22)'
            : '0 4px 14px rgba(220, 53, 69, 0.15)';
        }}
      >
        {/* Resim */}
        <div style={{ position: 'relative' }}>
          <img
            src={"https://mutfacik.s3.eu-central-1.amazonaws.com/" + food.foodImagePath}
            className="card-img-top"
            style={{ height: '160px', objectFit: 'cover', width: '100%' }}
            alt={food.foodNameTr}
          />
          <span
            className={`badge position-absolute top-0 end-0 m-2 ${food.foodIsEnabled ? 'bg-success' : 'bg-danger'}`}
            style={{ fontSize: '0.72rem', borderRadius: '8px', padding: '4px 8px' }}
          >
            {food.foodIsEnabled
              ? <><i className="bi bi-check-circle-fill me-1"></i>Aktif</>
              : <><i className="bi bi-slash-circle-fill me-1"></i>Pasif</>}
          </span>
        </div>

        {/* Kart içeriği */}
        <div className="card-body p-3 text-center d-flex flex-column">
          <h6 className="card-title fw-bold mb-1" style={{ fontSize: '0.95rem' }}>
            {food.foodNameTr}
          </h6>
          <div className="fw-bold mb-2" style={{ color: '#e67e00', fontSize: '1.05rem' }}>
            {food.hasDiscount && food.discountedPrice !== undefined ? (
              <>
                <s className="text-muted fw-normal me-2" style={{ fontSize: '0.85rem' }}>{food.foodPrice} TL</s>
                {food.discountedPrice} TL
                <span className="badge bg-warning text-dark ms-2" style={{ fontSize: '0.65rem' }}>
                  <i className="bi bi-percent"></i>
                </span>
              </>
            ) : (
              <>{food.foodPrice} TL</>
            )}
          </div>
          {food.foodContents && (
            <p
              className="card-text text-muted mb-2"
              style={{ fontSize: '0.75rem', lineHeight: '1.4', flexGrow: 1 }}
            >
              {food.foodContents.length > 70
                ? food.foodContents.substring(0, 70) + '…'
                : food.foodContents}
            </p>
          )}
          <div className="d-flex gap-2 mt-auto">
            <button
              className="btn btn-sm btn-outline-secondary flex-grow-1"
              onClick={() => EditFood(food)}
              style={{ borderRadius: '8px', fontWeight: 600 }}
            >
              <i className="bi bi-pencil-fill me-1"></i>Düzenle
            </button>
            <button
              className="btn btn-sm btn-outline-warning"
              onClick={(e) => { e.stopPropagation(); ManageDiscounts(food); }}
              style={{ borderRadius: '8px', fontWeight: 600, minWidth: '38px' }}
              title="Kampanyalar"
            >
              <i className="bi bi-percent"></i>
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={(e) => { e.stopPropagation(); handleDelete(food); }}
              disabled={deletingId === food.id}
              style={{ borderRadius: '8px', fontWeight: 600, minWidth: '38px' }}
              title="Sil"
            >
              {deletingId === food.id
                ? <span className="spinner-border spinner-border-sm" role="status" />
                : <i className="bi bi-trash-fill"></i>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  const SectionHeader = ({
    title,
    count,
    color,
    icon,
  }: {
    title: string;
    count: number;
    color: string;
    icon: string;
  }) => (
    <div className="d-flex align-items-center mb-3 mt-4">
      <div
        style={{
          width: '5px',
          height: '28px',
          backgroundColor: color,
          borderRadius: '3px',
          marginRight: '12px',
          flexShrink: 0,
        }}
      />
      <h5 className="mb-0 fw-bold" style={{ color }}>
        <i className={`bi ${icon} me-2`}></i>
        {title}
      </h5>
      <span
        className="badge ms-2"
        style={{ backgroundColor: color, fontSize: '0.78rem', borderRadius: '20px' }}
      >
        {count} ürün
      </span>
    </div>
  );

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-warning" role="status">
          <span className="visually-hidden">Yükleniyor...</span>
        </div>
        <div className="mt-2 text-muted small">Menü yükleniyor...</div>
      </div>
    );
  }

  if (!allFoods) {
    return <></>;
  }

  return (
    <div className="mt-3">

      {/* Silme Onay Modalı */}
      {confirmFood && (
        <div
          style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: 'rgba(0,0,0,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            backdropFilter: 'blur(3px)',
          }}
          onClick={() => setConfirmFood(null)}
        >
          <div
            style={{
              background: '#fff', borderRadius: '20px',
              padding: '32px 28px', maxWidth: '380px', width: '90%',
              boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
              textAlign: 'center',
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* İkon */}
            <div style={{
              width: '64px', height: '64px', borderRadius: '50%',
              background: '#fef2f2', display: 'flex', alignItems: 'center',
              justifyContent: 'center', margin: '0 auto 20px',
            }}>
              <i className="bi bi-trash3-fill" style={{ fontSize: '1.8rem', color: '#dc2626' }}></i>
            </div>

            {/* Başlık */}
            <h5 style={{ fontWeight: 800, color: '#111827', marginBottom: '8px' }}>
              Yemeği Sil
            </h5>

            {/* Yemek adı */}
            <p style={{ color: '#6b7280', fontSize: '0.9rem', marginBottom: '6px' }}>
              Aşağıdaki yemeği silmek istediğinize emin misiniz?
            </p>
            <div style={{
              background: '#fef2f2', border: '1.5px solid #fecaca',
              borderRadius: '10px', padding: '10px 16px',
              fontWeight: 700, color: '#991b1b', fontSize: '0.95rem',
              marginBottom: '24px',
            }}>
              <i className="bi bi-box-seam me-2"></i>{confirmFood.foodNameTr}
            </div>

            {/* Butonlar */}
            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={() => setConfirmFood(null)}
                style={{
                  flex: 1, padding: '10px', borderRadius: '10px',
                  border: '1.5px solid #e5e7eb', background: '#f9fafb',
                  color: '#374151', fontWeight: 600, fontSize: '0.9rem', cursor: 'pointer',
                }}
              >
                İptal
              </button>
              <button
                onClick={confirmDelete}
                style={{
                  flex: 1, padding: '10px', borderRadius: '10px',
                  border: 'none', background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                  color: '#fff', fontWeight: 700, fontSize: '0.9rem', cursor: 'pointer',
                  boxShadow: '0 4px 14px rgba(220,38,38,0.35)',
                }}
              >
                <i className="bi bi-trash-fill me-1"></i>Evet, Sil
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toplu Aç/Kapat Onay Modalı */}
      {bulkTarget !== null && (
        <div
          style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: 'rgba(0,0,0,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            backdropFilter: 'blur(3px)',
          }}
          onClick={() => !bulkBusy && setBulkTarget(null)}
        >
          <div
            style={{
              background: '#fff', borderRadius: '20px',
              padding: '32px 28px', maxWidth: '400px', width: '90%',
              boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
              textAlign: 'center',
            }}
            onClick={e => e.stopPropagation()}
          >
            <div style={{
              width: '64px', height: '64px', borderRadius: '50%',
              background: bulkTarget ? '#f0fdf4' : '#fff7ed',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 20px',
            }}>
              <i
                className={`bi ${bulkTarget ? 'bi-toggle-on' : 'bi-toggle-off'}`}
                style={{ fontSize: '1.8rem', color: bulkTarget ? '#16a34a' : '#ea580c' }}
              ></i>
            </div>

            <h5 style={{ fontWeight: 800, color: '#111827', marginBottom: '8px' }}>
              {bulkTarget ? 'Tüm Menüyü Aç' : 'Tüm Menüyü Kapat'}
            </h5>

            <p style={{ color: '#6b7280', fontSize: '0.9rem', marginBottom: '6px' }}>
              {bulkTarget
                ? 'Bu restorandaki bütün ürünler müşterilere açılacak.'
                : 'Bu restorandaki bütün ürünler müşterilere kapatılacak.'}
            </p>

            <div style={{
              background: bulkTarget ? '#f0fdf4' : '#fff7ed',
              border: `1.5px solid ${bulkTarget ? '#bbf7d0' : '#fed7aa'}`,
              borderRadius: '10px', padding: '10px 16px',
              fontWeight: 700, color: bulkTarget ? '#166534' : '#9a3412', fontSize: '0.92rem',
              marginBottom: '24px',
            }}>
              <i className="bi bi-box-seam me-2"></i>
              {bulkTarget
                ? `${passiveFoods.length} pasif ürün açılacak`
                : `${activeFoods.length} aktif ürün kapatılacak`}
            </div>

            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={() => setBulkTarget(null)}
                disabled={bulkBusy}
                style={{
                  flex: 1, padding: '10px', borderRadius: '10px',
                  border: '1.5px solid #e5e7eb', background: '#f9fafb',
                  color: '#374151', fontWeight: 600, fontSize: '0.9rem',
                  cursor: bulkBusy ? 'not-allowed' : 'pointer',
                }}
              >
                İptal
              </button>
              <button
                onClick={runBulkStatus}
                disabled={bulkBusy}
                style={{
                  flex: 1, padding: '10px', borderRadius: '10px', border: 'none',
                  background: bulkBusy
                    ? '#e5e7eb'
                    : bulkTarget
                      ? 'linear-gradient(135deg, #22c55e, #16a34a)'
                      : 'linear-gradient(135deg, #f97316, #ea580c)',
                  color: bulkBusy ? '#9ca3af' : '#fff',
                  fontWeight: 700, fontSize: '0.9rem',
                  cursor: bulkBusy ? 'not-allowed' : 'pointer',
                  boxShadow: bulkBusy
                    ? 'none'
                    : bulkTarget
                      ? '0 4px 14px rgba(22,163,74,0.35)'
                      : '0 4px 14px rgba(234,88,12,0.35)',
                }}
              >
                {bulkBusy
                  ? <><span className="spinner-border spinner-border-sm me-1" role="status" />İşleniyor...</>
                  : <><i className={`bi ${bulkTarget ? 'bi-toggle-on' : 'bi-toggle-off'} me-1`}></i>{bulkTarget ? 'Evet, Aç' : 'Evet, Kapat'}</>}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Popup: Yemek Düzenle */}
      <FoodUpdatePopup
        food={popupFood}
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        onSaved={handlePopupSaved}
      />

      {/* Popup: Yeni Yemek Ekle */}
      <AddNewFoodPopup
        isOpen={showNewPopup}
        onClose={() => setShowNewPopup(false)}
        onSaved={handlePopupSaved}
        restaurantId={selectedRestaurantId ?? ""}
      />

      {/* Popup: Kampanyalar */}
      <FoodDiscountPopup
        food={discountFood}
        isOpen={showDiscountPopup}
        onClose={() => setShowDiscountPopup(false)}
        onSaved={handlePopupSaved}
      />

      {/* Şu an çalışan kampanyalar */}
      {activeDiscounts.length > 0 && (
        <div className="alert d-flex align-items-start gap-2 mb-3" style={{ borderRadius: 12, background: '#fffbeb', border: '1.5px solid #fde68a' }}>
          <i className="bi bi-percent" style={{ fontSize: '1.2rem', color: '#b45309' }}></i>
          <div className="flex-grow-1">
            <div className="fw-bold mb-1" style={{ color: '#92400e' }}>
              Şu an {activeDiscounts.length} kampanya çalışıyor
            </div>
            <div className="d-flex flex-wrap gap-2">
              {activeDiscounts.map((d) => (
                <span key={d.id} className="badge bg-white border" style={{ color: '#92400e', fontWeight: 600, fontSize: '0.76rem' }}>
                  {d.foodNameTr ?? "Ürün"}: {d.discountType === "Percentage" ? `%${d.discountValue}` : `${d.discountValue} TL`}
                  {!d.endsAtUtc && (
                    <i className="bi bi-exclamation-triangle-fill text-danger ms-1" title="Bitiş tarihi yok — elle kapatılana kadar sürer"></i>
                  )}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Araç çubuğu: Yeni ekle + toplu menü durumu */}
      {selectedRestaurantId && (
        <div className="myfoods-toolbar mb-2">
          <button
            className="btn btn-success"
            style={{ borderRadius: '10px', fontWeight: 600 }}
            onClick={() => setShowNewPopup(true)}
          >
            <i className="bi bi-plus-lg me-1"></i>Yeni Yemek Ekle
          </button>

          {allFoods.length > 0 && (
            <div className="myfoods-bulk">
              <div className="myfoods-bulk__info">
                <span className="myfoods-bulk__dot" style={{ background: activeFoods.length > 0 ? '#22c55e' : '#d1d5db' }} />
                <span className="myfoods-bulk__count">
                  <strong>{activeFoods.length}</strong> / {allFoods.length}
                </span>
                <span className="myfoods-bulk__label">ürün açık</span>
              </div>
              <div className="myfoods-bulk__actions">
                <button
                  type="button"
                  className="myfoods-bulk__btn myfoods-bulk__btn--on"
                  disabled={bulkBusy || passiveFoods.length === 0}
                  title={passiveFoods.length === 0 ? "Zaten tüm ürünler açık" : "Menüdeki tüm ürünleri aç"}
                  onClick={() => setBulkTarget(true)}
                >
                  <i className="bi bi-toggle-on"></i>Tümünü Aç
                </button>
                <button
                  type="button"
                  className="myfoods-bulk__btn myfoods-bulk__btn--off"
                  disabled={bulkBusy || activeFoods.length === 0}
                  title={activeFoods.length === 0 ? "Zaten tüm ürünler kapalı" : "Menüdeki tüm ürünleri kapat"}
                  onClick={() => setBulkTarget(false)}
                >
                  <i className="bi bi-toggle-off"></i>Tümünü Kapat
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Toplu işlem sonucu */}
      {bulkResult && (
        <div className={`myfoods-bulk-result myfoods-bulk-result--${bulkResult.type}`}>
          <i className={`bi ${bulkResult.type === "success" ? "bi-check-circle-fill" : "bi-exclamation-circle-fill"}`}></i>
          <span>{bulkResult.text}</span>
          <button type="button" onClick={() => setBulkResult(null)} aria-label="Kapat">
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
      )}

      {/* Aktif Menü */}
      <SectionHeader title="Aktif Menü" count={activeFoods.length} color="#198754" icon="bi-check-circle-fill" />
      {activeFoods.length === 0 ? (
        <p className="text-muted ps-3 small">Aktif yemek bulunmuyor.</p>
      ) : (
        <div className="row g-2">
          {activeFoods.map(food => <FoodCard key={food.id} food={food} />)}
        </div>
      )}

      {/* Pasif Menü */}
      <SectionHeader title="Pasif Menü" count={passiveFoods.length} color="#dc3545" icon="bi-x-circle-fill" />
      {passiveFoods.length === 0 ? (
        <p className="text-muted ps-3 small">Pasif yemek bulunmuyor.</p>
      ) : (
        <div className="row g-2" style={{ opacity: 0.75 }}>
          {passiveFoods.map(food => <FoodCard key={food.id} food={food} />)}
        </div>
      )}
    </div>
  );
}

export default MyFoods;